import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import Button from '@saucelabs/sl-component-buttons';
import { CheckboxField } from '@saucelabs/sl-component-form';
import { Col } from '@saucelabs/sl-component-grid';
import { Tab } from '@saucelabs/sl-component-tabs';
import { recordTrack as recordTrackAction } from '@saucelabs/sl-util-segmentio';

import * as utils from '../../utils';
import Styles from './ConfigsContainer.styles';
import ConfigsTabs from '../../components/ConfigsList/ConfigsTabs';
import ConfigsList from '../../components/ConfigsList/ConfigsList';
import ConfigsListItem from '../../components/ConfigsList/ConfigsListItem';

const context = classNames.bind(Styles);

const ConfigsContainer = memo((props) => {
  const {
    className,
    onToggleSaveConfig,
    recentConfigs,
    recordTrack,
    savedConfigs,
    submitDisabled,
    onItemClick,
  } = props;

  const renderConfigItem = (config) => (
    <ConfigsListItem
      key={config.id}
      formType={utils.getFormType(
        config.platformType,
        config.device,
        config.deviceType,
      )}
      onClick={() => {
        recordTrack('Manual Selected Saved Config');
        onItemClick(config);
      }}
      {...config}
    />
  );

  return (
    <Col
      className={classNames(Styles.default, className)}
      xs
    >
      <div className={Styles.content}>
        <ConfigsTabs
          defaultActiveKey="recent"
          onSelect={(key) => recordTrack('Manual Select ConfigsTabs', { key })}
        >
          <Tab
            eventKey="recent"
            title="Recent"
          >
            <ConfigsList>
              {recentConfigs.map(renderConfigItem)}
            </ConfigsList>
          </Tab>
          <Tab
            eventKey="saved"
            title="Saved"
          >
            <ConfigsList>
              {savedConfigs.map(renderConfigItem)}
            </ConfigsList>
          </Tab>
        </ConfigsTabs>

        <div className={Styles['save-configuration']}>
          <CheckboxField
            fieldName="saveConfiguration"
            id="saveConfiguration"
            label="Save this configuration"
            name="saveConfiguration"
            onChange={(event) => {
              recordTrack('Manual Toggle Save Config', { checked: event.target.checked });
              onToggleSaveConfig(event.target.checked);
            }}
            value="saveConfiguration"
          />
        </div>

        <div className={context('session-start', {
          disabled: submitDisabled,
        })}
        >
          <Button
            block
            category="success"
            disabled={submitDisabled}
            type="submit"
          >
            Start session
          </Button>
        </div>
      </div>
    </Col>
  );
});

ConfigsContainer.propTypes = {
  className: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
  onToggleSaveConfig: PropTypes.func.isRequired,
  recentConfigs: PropTypes.array.isRequired,
  recordTrack: PropTypes.func.isRequired,
  savedConfigs: PropTypes.array.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
};

ConfigsContainer.defaultProps = {
  className: '',
};

const mapDispatchToProps = {
  recordTrack: recordTrackAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(ConfigsContainer);
export { ConfigsContainer };
